// extracted by mini-css-extract-plugin
module.exports = {"head":"style_head__1NGsz","title":"style_title__aEnnY","time":"style_time__T35ap","content":"style_content__10JHY","tabs":"style_tabs__UoW-B"};